import React from 'react'
import Layout from '../../../brands/components/Layout'
import { ProfileImg } from '../../../../assets/images'
import { Formik } from 'formik'
import { InputField } from '../../../../components'
import SelectField from '../../../../components/Form/Select'

const EditProfile: React.FC = () => {
    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Manage Profile</h4>
                    </div>
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="d-flex align-items-center profile-img">
                                <img src={ProfileImg} />
                                <div className="user-overview">
                                    <h4>Julia Smith</h4>
                                    <h5>SuperAdmin</h5>
                                    <h6>Vancouver, Canada</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 button-block">
                            <div className="custom-btn-design">
                                <a className="button button-primary">
                                    SAVE INFO
                                </a>
                                <a className="button button-outline">CANCEL</a>
                            </div>
                        </div>
                    </div>

                    <div className="user-form mt-3">
                        <Formik
                            initialValues={{
                                email: '',
                                password: '123Pa$$word!',
                            }}
                            onSubmit={() => console.log('')}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="email"
                                                lable={'First Name'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <InputField
                                                type="email"
                                                lable={'Last Name'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="exampleSelect"
                                                label="Gender"
                                                options={[
                                                    {
                                                        value: 'Male',
                                                        label: 'Male',
                                                    },
                                                    {
                                                        value: 'Female',
                                                        label: 'Female',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <InputField
                                                type="date"
                                                lable={'Birthday'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="email"
                                                lable={'Address'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="exampleSelect"
                                                label="Country"
                                                options={[
                                                    {
                                                        value: 'India',
                                                        label: 'India',
                                                    },
                                                    {
                                                        value: 'Australia',
                                                        label: 'Australia',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="exampleSelect"
                                                label="State/Province"
                                                options={[
                                                    {
                                                        value: 'India',
                                                        label: 'India',
                                                    },
                                                    {
                                                        value: 'Australia',
                                                        label: 'Australia',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <InputField
                                                type="email"
                                                lable={'Postal Code'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default EditProfile
